import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import { useMemo, useRef, useEffect } from "react";
import {ParagraphCustom} from "../../../../ui/atoms/ParagraphCustom";
import { campaigns } from "../../../../data/Data";
import { item_listAnimation, listAnimation } from "../../../../Variables";
import useMobile from "../../../../hooks/useMobile";
import { useNavigate } from "react-router-dom";

export const CampaignsList = ({ categorySected }) => {
    const isMobile = useMobile();
    
    const filteredCompaigns = useMemo(() => {
        const activeCampaigns = campaigns?.filter(item => item.status === true);
        if (!categorySected) return activeCampaigns.slice(0,5);
        const actCamp = activeCampaigns?.filter(c => c.category.includes(categorySected));
        return actCamp.slice(0,5)
    }, [categorySected]);

    const ref = useRef();
    
    const { scrollYProgress } = useScroll({
        target: ref,
    });

    const smoothVelocity = useSpring(scrollYProgress, {
        damping: 100,
        stiffness: 400,
    });
    
    const x = useTransform(smoothVelocity, [0, 1], [
        isMobile ? "5%" : "5%", 
        isMobile ? "-75%" : "-15%"
    ]);

    const navigate = useNavigate();

    const handleShowCampaign = (slug) => {
        if (!slug) return;
        navigate(`/campagnes/${slug}`);
    }

    // Réinitialiser le scroll quand la catégorie change
    useEffect(() => {
        if (ref.current) {
            window.scrollTo(0, 0);
        }
    }, [categorySected]);

    return (
        <div ref={ref} className="w-full lg:h-[300vh] h-[300vh] bg-black flex items-start justify-center gap-10 relative">
            <motion.div
                style={{
                    scaleX: scrollYProgress,
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 4,
                    originX: 0,
                    backgroundColor: "#f97316",
                }}
            />
            <div className="sticky top-0 left-0 h-screen w-full flex items-center justify-start overflow-hidden">
                <motion.div 
                    style={{ x }}
                    className="flex items-center justify-start min-w-screen"
                >
                    <motion.ul 
                        className="flex items-center gap-10 px-4"
                        variants={listAnimation}
                        initial="hidden"  
                        animate="show"
                        key={categorySected}
                    >
                        {filteredCompaigns?.map((item, index) => (
                            <motion.li 
                                key={`${item.id}-${index}`} 
                                className="cursor-pointer lg:h-[55vh] h-96 w-60 lg:min-w-[350px] rounded-sm relative overflow-hidden"
                                variants={item_listAnimation} 
                                transition={{type:"spring", stiffness:400, damping:70, ease:"easeInOut"}}
                                onClick={() => handleShowCampaign(item.slug)}
                            >
                                <motion.figure 
                                    className="lg:h-[55vh] h-96 w-60 lg:min-w-[350px]"
                                    whileHover={{scale: 1.045 }}    
                                    whileTap={{ scale: .945 }}
                                    transition={{type:"spring", stiffness:400, damping:70, ease:"easeInOut"}}
                                >
                                    <img 
                                        src={`${process.env.REACT_APP_URL_CLOUDFARE}images/${item.mainImage}.webp`} 
                                        className="lg:opacity-75 opacity-80 w-full h-full lg:rounded-xl rounded-sm object-cover" 
                                        alt="une campagne de mobali" 
                                    />
                                </motion.figure>
                            </motion.li>
                        ))}
                    </motion.ul>
                </motion.div>

                <ParagraphCustom className="text-slate-500 absolute left-1/2 transform -translate-x-1/2 bottom-20 flex items-center gap-4">
                    <span className="h-[1px] order-first bg-slate-400 w-10 block"></span>
                        Campagnes
                    <span className="h-[1px] bg-slate-400 w-10 block"></span>
                </ParagraphCustom>
            </div>
        </div>
    );
};